import React, {useState} from 'react'

export interface OrganizationThemeContextProps {
  SidebarHandle: () => void
  setIsCollapse: React.Dispatch<React.SetStateAction<boolean>>
  isCollapse: boolean
}

export const OrganizationThemeContext = React.createContext<
  OrganizationThemeContextProps | undefined
>(undefined)

export default function OrganizationThemeProvider(props: {
  children: React.ReactElement
}) {
  const [isCollapse, setIsCollapse] = useState<boolean>(false)

  const SidebarHandle = () => {
    setIsCollapse(!isCollapse)
  }

  return (
    <OrganizationThemeContext.Provider
      value={{
        setIsCollapse,
        SidebarHandle,
        isCollapse,
      }}
    >
      {props.children}
    </OrganizationThemeContext.Provider>
  )
}

export function useOrganziationTheme() {
  const context = React.useContext(OrganizationThemeContext)
  if (context === undefined) {
    throw new Error(
      'useOrganziationTheme must be used within OrganizationThemeProvider',
    )
  }
  return context
}
